const errorCreatedHeaders = [
  {
    text: 'STT',
    value: 'index',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Tên học sinh',
    value: 'studentName',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Lớp',
    value: 'studentClass',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false,
  },
]

export { errorCreatedHeaders }
